<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle text-h4 font-weight-bold">
          {{title}}
        </div>
        <!-- <v-btn depressed color="success" class="btn_fontSize ml-2 pa-1 text-h5" @click="openDialog('add')">{{$t("CaseManage.CaseList.Add")}}</v-btn> -->
        <!--<div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile(tables.lang_info)">匯出</v-btn>
        </div>-->
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.lang_info.page"
            :length="tables.lang_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          {{$t("Table.PreTotal")}} {{tables.lang_info.total}} {{$t("Table.PostTotal")}}
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="min-width:190px; max-width:270px">
          <v-select
            :items="tables.lang_info.rowsList"
            v-model="tables.lang_info.rows"
            class="rounded-lg"
            outlined
            dense
            hide-details
            :prefix="$t('Table.PrePage')"
            :suffix="$t('Table.PostPage')"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.lang_info.data"
        :headers="tables.lang_info.headers"
        hide-default-header
        :items-per-page="tables.lang_info.rows"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.lang_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header, tables.lang_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.lang_info.sortItem===header.value">
                    <v-icon v-if="tables.lang_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.lang_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  :disabled="item.Abbreviation === $store.state.lang"
                  :style="item.Abbreviation === $store.state.lang ? 'cursor: pointer;' : 'cursor: default;'"
                  @click="ApplyLanguage(item.Abbreviation)"
                >{{ item.Abbreviation === $store.state.lang ? 'mdi-cog-outline' : 'mdi-cog-play-outline' }}
                  
                </v-icon>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>

export default {
  name: 'Language_info',
  data() { return ({
    title: 'Language Management',
    tables: {
      lang_info: {
        headers: [
          { text: 'Id', value: 'Id',  sortable: false },
          { text: 'Language Name', value: 'Name',  sortable: false },
          { text: 'Abbreviation', value: 'Abbreviation',  sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        rows: 10,
        sortItem: 'DisplayGroup',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10],
        search: {

        },
        data: [
          {Id:'1', Name:'Traditional Chinese', Abbreviation:'zh-TW'},
          {Id:'2', Name:'English', Abbreviation:'en-US'},
          {Id:'3', Name:'Japanese', Abbreviation:'ja-JP'},
        ],
        selectedData: { 
          Id: 0,
          Name: null,
          Abbreviation: null,
        },
        defaultData: { 
          Id: 0,
          Name: null,
          Abbreviation: null,
        },
        isEdit: false,
        dialogAdd: false,
        dialogDelete: false
      },
      ui:{
        add: '',
        total:{ pre:'', post:''},
        pageRows:{ pre:'', post:''},
      }
    },
    rules: {
      //content: [v => !!v || 'Required']
      content: [v => (v !== null && v !== '' && v.toString().length > 0) || 'Required']
    },
    sidebar: {
      open: true, 
      width: 260,
      icon: 'mdi-arrow-expand-left',
      iconClass: 'mr-5',
      title: this.$t('Filter.filter')
    },
    dictionary: {
      Category:  [ { text: '', value:'' }, ],
    },
    consts:{
      VALUE_ZERO: 0,
      VALUE_ONE: 1,
    }
  })},
  mounted: function () {
    this.$emit('setAppbar', { isHide: false })
  },
  watch: {
    'sidebar.open' () {
        this.sidebar.width = this.sidebar.open ? 260 : 70
        this.sidebar.icon = this.sidebar.open ? 'mdi-arrow-expand-left' : 'mdi-tune-variant'
        this.sidebar.iconClass = this.sidebar.open ? 'mr-5' : 'mr-5 my-5'
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
  },
  methods: {
    showAlert (type, message) {
      let alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
      if (!header.sortable) return

      if (header.value === table.sortItem) {
        table.sortOrder = !table.sortOrder
      } else {
        table.sortOrder = true
        table.sortItem = header.value
      }
      this.getPageData(table)
    },
    ApplyLanguage (value) {
      this.$store.commit('setLang', value)
      this.$i18n.locale = value
    }
  }
}
</script>
